import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pa-4 d-flex items-center" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = { class: "d-flex px-6 sleep-curve-content pb-6" }
const _hoisted_4 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_5 = { class: "percentage" }
const _hoisted_6 = { class: "d-flex justify-center items-center label" }
const _hoisted_7 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_8 = { class: "percentage" }
const _hoisted_9 = { class: "d-flex justify-center items-center label" }
const _hoisted_10 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_11 = { class: "percentage" }
const _hoisted_12 = { class: "d-flex justify-center items-center label" }
const _hoisted_13 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_14 = { class: "percentage" }
const _hoisted_15 = { class: "d-flex justify-center items-center label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_circle = _resolveComponent("van-circle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont iconreport-icon-dahan title-icon" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("snoreLevel.snoreLevel")), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_my_card_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              ref: $setup.setRef,
              style: {"height":"60vw","width":"100%"}
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_non_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BFA94",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("label", null, _toDisplayString($props.snore_non_proportion), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("span", null, "%", -1))
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("snoreLevel.none")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_low_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BFAE4",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", null, _toDisplayString($props.snore_low_proportion), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("span", null, "%", -1))
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("snoreLevel.light")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_mid_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BC6FA",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", null, _toDisplayString($props.snore_mid_proportion), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "%", -1))
                    ]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("snoreLevel.medium")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_high_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#DA6BFA",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", null, _toDisplayString($props.snore_high_proportion), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "%", -1))
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("snoreLevel.heavy")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_cell_group, { border: false }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell, {
                  class: "cell-item",
                  title: _ctx.$t('snoreLevel.snoreNumber'),
                  value: $props.snore_number
                }, null, 8, ["title", "value"]),
                _createVNode(_component_van_cell, {
                  title: _ctx.$t('snoreLevel.snoreDuration'),
                  value: 
              `${$setup.duration($props.snore_duration).hours}H${
                $setup.duration($props.snore_duration).minutes
              }M`
            
                }, null, 8, ["title", "value"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}